import "./index.css";
import {AuthZTable, defaultPageSize, defaultPageSizeOptions,} from "../../../../../../components/authZTable";
import {ApplicationUserAccessController} from "./controller";
import React from "react";
import {getUserAccessTableId} from "./model";
import {userAccessColumnGenerator} from "./columnGenerator";

export const ApplicationUserAccess = ({appId, pageSize, setTabPageSize,activeTabId, accessTypeLink}) => {
  const {dataSource, columns, isLoading, selectedColumns, totalColumns} =
    ApplicationUserAccessController(appId,activeTabId);
  let modifiedColumns = userAccessColumnGenerator(columns, accessTypeLink);

  modifiedColumns =modifiedColumns.filter(({title}) => {
      return selectedColumns.includes(title) || !totalColumns.includes(title);
  });

  return (
      <AuthZTable
        name={"userAccess"}
        id={getUserAccessTableId(appId)}
        columns={modifiedColumns}
        dataSource={dataSource}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: defaultPageSizeOptions,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          defaultPageSize: defaultPageSize,
          pageSize: pageSize,
          defaultCurrent: 1,
          showQuickJumper: true,
          onShowSizeChange: (_current, size) => {
            setTabPageSize({pageSize: size});
          },
        }}
        scroll={{x: "max-content", y: "calc(100vh - 355px)"}}
        loading={isLoading}
      />
  );
};
